module.exports = __webpack_public_path__ + "static/media/asus.693a6f22.svg";